<template>
  <detail
    :on-manager="onManager"
    :data="data"
    :base-info="baseInfo"
    :extra-info="extraInfo" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import { getEnabledTableColumn, getProjectDomainTableColumn, getTimeTableColumn, getApplicationScopeTableColumn } from '@/utils/common/tableColumn'
import { REPORT_TEMPLATES } from '@Reports/constants'
import ResourceList from '@Reports/views/custom-report/templates/ResourceList.vue'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'ReportTemplateDetail',
  components: {
    // eslint-disable-next-line vue/no-unused-components
  },
  mixins: [WindowsMixin, ColumnsMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        getEnabledTableColumn(),
        {
          field: 'type',
          title: this.$t('report.template_type'),
          formatter: ({ row }) => {
            return this.$te(`report.template_type.${row.type}`) ? this.$t(`report.template_type.${row.type}`) : row.type || '-'
          },
        },
        getProjectDomainTableColumn({ vm: this }),
        getApplicationScopeTableColumn({
          vm: this,
          resource: 'report_templates',
          scope: 'domain',
        }),
        getTimeTableColumn(),
      ],
      extraInfo: [
        {
          title: this.$t('report.template_preview'),
          items: [
            {
              field: 'template',
              slots: {
                default: ({ row }, h) => {
                  // ResourceList 预览直接使用组件本身，避免常量中的 component 受循环依赖影响为空
                  if (row.type === 'ResourceList') {
                    return h(ResourceList, {
                      props: {
                        reportData: row.options || row,
                        isTemplate: true,
                        isTemplateEdit: false,
                        scopeParams: {
                          project_id: this.$store.getters.userInfo?.projectId,
                          domain_id: this.$store.getters.userInfo?.project?.domain_id,
                        },
                      },
                    })
                  }
                  // 其它模板仍使用 REPORT_TEMPLATES 中注册的组件
                  if (REPORT_TEMPLATES[row.type] && REPORT_TEMPLATES[row.type].component) {
                    return h(REPORT_TEMPLATES[row.type].component, {
                      props: {
                        reportData: row,
                      },
                    })
                  }
                  return null
                },
              },
            },
          ],
        },
      ],
    }
  },
}
</script>
